import React from "react";
import { useQuery } from "@tanstack/react-query";
import api, { fmtDate } from "../lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../components/ui/table";

export default function Audit() {
  const { data = [] } = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/audit")).data });
  return (
    <div>
      <h1 className="text-2xl font-head font-bold mb-1">Audit log</h1>
      <p className="text-sm text-muted-foreground mb-5">Registro delle azioni sugli archivi</p>
      <div className="gr-card overflow-hidden">
        <Table>
          <TableHeader><TableRow className="bg-secondary/60"><TableHead className="font-bold">Data/ora</TableHead><TableHead className="font-bold">Utente</TableHead><TableHead className="font-bold">Azione</TableHead><TableHead className="font-bold">Sezione</TableHead><TableHead className="font-bold">Record</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-10 text-muted-foreground">Nessun evento</TableCell></TableRow>}
            {data.map((a) => (
              <TableRow key={a.id} data-testid={`audit-${a.id}`}>
                <TableCell className="text-xs tabnum">{new Date(a.created_at).toLocaleString("it-IT")}</TableCell>
                <TableCell className="font-semibold">{a.user_name}</TableCell>
                <TableCell className="capitalize">{a.action}</TableCell>
                <TableCell className="capitalize">{a.section}</TableCell>
                <TableCell className="text-xs text-muted-foreground">{a.record_id?.slice(-6) || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
